import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { UpsellFlowControllerPage } from './upsell-flow-controller.page';

const routes: Routes = [
  {
    path: '',
    component: UpsellFlowControllerPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UpsellFlowControllerPageRoutingModule {}
